import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { TCreateOrganizationDTO } from '@/pages/Organizations/organizations.types.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import organizationsApi from '@/pages/Organizations/organizations.api.ts'
import organizationsEvents from '@/pages/Organizations/events/organizations.events.ts'
import OrganizationFormFields from '@/pages/Organizations/components/OrganizationFormFields'

interface IProps {
  open: boolean
  onClose: () => void
}

const CreateOrganizationSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [state, _, handleChange] = useStateWithChange<TCreateOrganizationDTO>({
    name: '',
    contact: '',
    tin: '',
    active: true,
  })

  const handleCreate = () => {
    wait(organizationsApi.create(state), (resp) => {
      if (resp.status === 'success') {
        organizationsEvents.created(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h4 className="text-heading-4">Создание организации</h4>
        <SeparateLine />
        <OrganizationFormFields organization={state} onChange={handleChange} />
        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button
            size="default"
            type="primary"
            onClick={handleCreate}
            text="Сохранить"
            disabled={!state.name}
            loading={loading}
          />
          <Button size="default" type="default" onClick={props.onClose} disabled={loading} text="Отмена" />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateOrganizationSidePage
